/**
 * @fileoverview จำว่าเบราว์เซอร์นี้เคยเข้าระบบด้วยบัญชี LINE ที่ผูกไว้แล้ว
 * @module utils/lineLogin
 *
 * ใช้ตัดสินตั้งแต่ตอนกดปุ่มว่าจะขอให้ LINE ข้ามหน้ายินยอมได้เลยไหม
 * จะได้ไม่ต้องวิ่งไป LINE สองรอบ (รอบแรกลองข้าม รอบสองค่อยขอยินยอม)
 *
 * เก็บเป็นคุกกี้ ไม่ใช่ localStorage เพราะตอนออกจากระบบมี localStorage.clear()
 * ค่านี้เป็นแค่ตัวช่วยเรื่องขั้นตอนการกด ไม่ใช่ข้อมูลยืนยันตัวตน —
 * ต่อให้ถูกแก้ก็ได้แค่หน้ายินยอมโผล่หรือไม่โผล่ ส่วนสิทธิ์เข้าระบบ backend ตรวจเองทุกครั้ง
 */

const COOKIE_NAME = "mn-line-linked";
const ONE_YEAR = 60 * 60 * 24 * 365;

export const isLineLinkedBrowser = () =>
  document.cookie.split("; ").some((item) => item.trim() === `${COOKIE_NAME}=1`);

export const rememberLineLinked = () => {
  document.cookie = `${COOKIE_NAME}=1; path=/; max-age=${ONE_YEAR}; samesite=lax`;
};

export const forgetLineLinked = () => {
  document.cookie = `${COOKIE_NAME}=; path=/; max-age=0; samesite=lax`;
};

const lineLoginUtils = { isLineLinkedBrowser, rememberLineLinked, forgetLineLinked };

export default lineLoginUtils;
